import { useMetadata } from '#wa/composables/useMetadata'

export function syrahShirazFiltersToUrl(filters) {
  if (
    filters.length === 2 &&
    filters.every(
      (filter) =>
        filter.category === 'varietals' &&
        ['syrah', 'shiraz'].includes(filter.key),
    )
  ) {
    return `varietals/syrah-shiraz/`
  }
  return undefined
}

export function syrahShirazUrlToFilters({ route }) {
  const metadata = useMetadata()
  if (
    route.params.category !== 'varietals' ||
    route.params.slug !== 'syrah-shiraz' ||
    !metadata.searchFilters
  )
    return undefined
  return metadata.searchFilters.filter(
    (filter) =>
      filter.category === 'varietals' &&
      ['syrah', 'shiraz'].includes(filter.key),
  )
}
